import { render, staticRenderFns } from "./PurchaseDeliveryDetail.vue?vue&type=template&id=17794234&scoped=true"
import script from "./PurchaseDeliveryDetail.vue?vue&type=script&lang=js"
export * from "./PurchaseDeliveryDetail.vue?vue&type=script&lang=js"
import style0 from "./PurchaseDeliveryDetail.vue?vue&type=style&index=0&id=17794234&prod&lang=scss"
import style1 from "./PurchaseDeliveryDetail.vue?vue&type=style&index=1&id=17794234&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17794234",
  null
  
)

export default component.exports